module.exports = __webpack_public_path__ + "static/media/9.556a532b.svg";